import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Authorization header from localStorage if present (fallback for cross-site cookie blocks)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Global 401 handler — session expired ⇒ clear token & bounce to login.
// Skip for /auth/me and /auth/login so AuthContext can handle initial checks itself.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthCheck = url.includes("/auth/me") || url.includes("/auth/login");
    if (status === 401 && !isAuthCheck) {
      localStorage.removeItem("access_token");
      if (window.location.pathname !== "/") {
        window.location.href = "/?session=expired";
      }
    }
    return Promise.reject(error);
  }
);

// Map FastAPI validation errors to a string
export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
